import React, { useState } from "react"

export const ActiveContentContext = React.createContext()

export const useActiveContentContext = () => {
  const context = React.useContext(ActiveContentContext)
  if (context === undefined) {
    throw new Error(
      "useActiveContentContext must be used within an ActiveContentProvider"
    )
  }
  return context
}

const ActiveContentProvider = ({ children }) => {
  const [activeContent, setActiveContent] = useState({
    relatedId: 0,
    subRelatedId: 0,
    screen: "content",
  })

  return (
    <ActiveContentContext.Provider value={{ activeContent, setActiveContent }}>
      {children}
    </ActiveContentContext.Provider>
  )
}

export default ActiveContentProvider
